import { CommonOption } from "types/common";
import dataEN from "../assets/countries/en.json";
import dataRU from "../assets/countries/ru.json";

export type CountryOption = CommonOption & {
  label: string;
};

const RESTRICTED_COUNTRY_CODES = [
  "AF",
  "CU",
  "IR",
  "MM",
  "KP",
  "SY",
  "VE",
] as const;
const BILLING_ADDRESS_EXCLUDED_COUNTRY_CODES = ["BY", "RU"] as const;

const getCountriesData = (locale = "en") => {
  const lang = locale.toLowerCase();

  return lang === "ru" ? dataRU : dataEN;
};

export const getCountryByCode = (countries: CountryOption[], code: string) =>
  countries.find((country) => country.value === code);

export const getCountriesOptions = (
  locale = "en",
  excludedCountryCodes: readonly string[] = [],
): CountryOption[] => {
  const excludedCodes = new Set([
    ...RESTRICTED_COUNTRY_CODES,
    ...excludedCountryCodes,
  ]);

  return Object.values(getCountriesData(locale))
    .filter(({ iso }) => !excludedCodes.has(iso))
    .map((value) => ({
      label: value.name,
      value: value.iso,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const getBillingAddressCountriesOptions = (
  locale = "en",
): CountryOption[] =>
  getCountriesOptions(locale, BILLING_ADDRESS_EXCLUDED_COUNTRY_CODES);
